<template> 
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                资讯列表   
            </div>
            <div>
                <h2 class="txt_l">列表搜索</h2>
                <div class="search1">
                    <Input  ref='isFocuseA' size="large"   :maxlength='20' @keyup.enter.native="searchFun1" v-model="search1_inp"  class='ipt   top13 '  placeholder="请输入"  >
                        <Button    @click='searchFun1'  type="primary"   slot="append" >搜索</Button>
                    </Input>
                </div>
                <div>
                    <Tabs :value="search.search2" @on-click="searchFun2">
                        <TabPane v-for="item in searchs2" :key="item.title" :label="item.name" :name="item.title"   ></TabPane>
                    </Tabs>
                    <div class="leimu" >
                        <ul :class="['bottom_line2','listUl',zk?'zkh':'']"  >
                            <li class="zk pointer" @click="zkFun">展开</li>
                            <li class="inline list_btn lft">所属类目：</li>

                            <li :class="[search.search3 == 'all'?'search3_active':'','inline','list_btn','lft']" @click="searchFun3('all')">全部</li>
                            <li   v-for="item in searchs3" :class="[search.search3 == item.guid?'search3_active':'','inline','list_btn','lft']" @click="searchFun3(item.guid)" :id="item.guid" :key="item.guid">{{item.name}}</li>
                        </ul>
                        <div class="lb txt_l">
                            <span class="lbs  inline list_btn lft">其它搜索：</span> 
                            <span class="lbs  inline list_btn lft">浏览数：</span> 
                            <Input  class='ipt   top10 width250 lft' type="number"  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="searchFun4" v-model="search4_inp"    placeholder="请输入"  >
                                <Button    @click='searchFun4'  type="primary" icon="md-search"   slot="append" ></Button>
                            </Input>
                        </div>
                    </div>
                </div>
            </div>

            <c-content :search="search"></c-content>
            <!-- 富文本 -->
            <!-- <fwb></fwb> -->
        </div>
    </div>
</template> 
<script>
    import fwb from '../../child_vue/fwb.vue';
    import cNew from './consultationList/consultationListNew.vue';
    import cContent from './consultationList/consultationListContent.vue';
   
    export default {
        data () {
            return {
                search:{
                    search1: null,
                    search2: '0',
                    search3: 'all',
                    search4: null
                },
                search1_inp: null,
                search4_inp: null,
                searchs2: [{title:'0',name:'全部'},{title:'1',name:'文章'},{title:'2',name:'图集'},{title:'3',name:'视频'}],
                searchs3: null,
                zk: true,
            }
        },
        components:{
            "fwb":fwb,
            "cNew":cNew,
            "cContent":cContent,
        },
        computed: {
        
        },
        methods: {
          load(){

          },
          load_class(){
              let that = this;
              that.$myAjax.get(
                    'admin/service/admin/news/type/select'
              ).then(res => {
                  let data = res.data.data;
                  that.searchs3 = data;
                
              })
          },
          searchFun1(){
              this.search.search1 = this.search1_inp;

              this.search.search2 = '0',
              this.search.search3 = 'all',
              this.search.search4 = null
              this.search4_inp = null
          },  
          searchFun2(title){
              this.search.search2 = title;

              this.search.search1 = null;
              this.search1_inp = null;
              this.search.search4 = null;
              this.search4_inp = null;
          },  
          searchFun3(title){
              this.search.search3 = title;

              this.search.search1 = null;
              this.search1_inp = null;
              this.search.search4 = null;
              this.search4_inp = null;
          },  
          searchFun4(){
              this.search.search4 = this.search4_inp;

              this.search.search1 = null;
              this.search1_inp = null;
              this.search.search2 = '0';
              this.search.search3 = 'all';
          },  
          
          zkFun(){
              
              this.zk = !this.zk;
              console.log(this.zk)
          }
          
        },
      
        mounted: function(){
            var that = this;
            that.load_class();
        }
    }
</script>  
<style scoped>
    .search1 .ipt{
        width: 44%;
        margin-left: 28%;
    }
    .search1 .ivu-input-group-append{
        background: #2d8cf0;
        color: white;
        position: relative;
        border: 0;
    }
    .leimu{
        margin: 0 20px;
        overflow: hidden;
    }
    .listUl{
        position: relative;
        padding-right: 40px;
        padding-bottom: 5px;
        margin-bottom: 5px;
        overflow: hidden;
    }
    .zk{
        position: absolute;
        top: 0;right: 0;
        color: #2d8cf0;
        padding: 5px;
    }
    .zkh{
        height: 35px;
    }
    .lbs{
        margin-top: 12px!important;
        margin-bottom: 10px;
    }
    .search3_active{
        background: #2d8cf0;
        color: white;
    }
</style>
     